var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Retriever } from "../../../../common";
export class DatesRetriever extends Retriever {
    constructor(datesGateway, hideTabEvent, clock, timeZoneObservable, keepSelectedDay) {
        super();
        this.datesGateway = datesGateway;
        this.toggleTabEvent = hideTabEvent;
        this.clock = clock;
        this.timeZoneObservable = timeZoneObservable;
        this.midnightUpdateTimeout = -1;
        this.addTimeAfterMidnight = 1000;
        this.keepSelectedDay = keepSelectedDay;
        this.isActive = false;
        this.timeZoneObservable.observe((timeZone) => this.updateTimeZone(timeZone)).catch((err) => { });
    }
    setParams(sportId, parentBlockId) {
        return __awaiter(this, void 0, void 0, function* () {
            this.sportId = sportId;
            this.parentBlockId = parentBlockId;
            if (this.isActive) {
                yield this.refreshData();
                if (!this.keepSelectedDay && this.state && this.state.Items.length) {
                    this.state.selectItem(this.state.Items[0]);
                }
            }
        });
    }
    activate(state) {
        return __awaiter(this, void 0, void 0, function* () {
            this.isActive = true;
            this.state = state;
            yield this.refreshData();
        });
    }
    refreshData() {
        return __awaiter(this, void 0, void 0, function* () {
            this.currentSelectedTimeZone != undefined && this.sportId && (yield this.pullItems(this.currentSelectedTimeZone, this.sportId));
        });
    }
    updateTimeZone(timezone) {
        return __awaiter(this, void 0, void 0, function* () {
            this.currentSelectedTimeZone = timezone;
            this.sportId && (yield this.pullItems(timezone, this.sportId));
        });
    }
    pullItems(timezone, sportId) {
        return __awaiter(this, void 0, void 0, function* () {
            this.resetMidnightUpdateTimer(timezone, sportId);
            const dates = yield this.datesGateway.GetDates(timezone, sportId);
            this.parentBlockId && this.toggleTabEvent.emit(dates, this.parentBlockId);
            this.isActive && this.state.replaceItems(dates, true);
        });
    }
    resetMidnightUpdateTimer(timezone, sportId) {
        clearTimeout(this.midnightUpdateTimeout);
        const timeTillMidnight = this.clock.getTimeTillMidnight(timezone);
        this.midnightUpdateTimeout = window.setTimeout(() => this.pullItems(timezone, sportId), timeTillMidnight + this.addTimeAfterMidnight);
    }
    deactivate() {
        this.isActive = false;
        clearTimeout(this.midnightUpdateTimeout);
        this.datesGateway.deactivate();
    }
}
//# sourceMappingURL=DatesRetriever.js.map